"use client"

import { useEffect } from "react"
import { reportFrontendError } from "@/shared/lib/frontend-error-reporter"

export default function RootError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    reportFrontendError(error, { source: "react-boundary", digest: error.digest })
  }, [error])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h2 className="text-xl font-semibold">페이지를 불러오지 못했습니다.</h2>
      <button type="button" className="rounded bg-[#6B00D7] px-5 py-2 text-white" onClick={reset}>
        다시 시도
      </button>
    </div>
  )
}
